
  <app-nav></app-nav>
  <main class="page page-information">

    <aside class="header-image-half"></aside>

    <div class="container content-section">

      <h1 class="content-section-title text-right mt-0" translate="termsandcondition">
      </h1>

      <div class="row">
        <div class="col-md-12" [innerHTML]="model">

        </div>
      </div>
    </div>

  </main>
  <app-footer></app-footer>
